import React, { useState } from "react"
import { Link } from "react-router-dom"
import * as moment from "moment"
import {
  Badge,
  Button,
} from "reactstrap"
import {
  USDFormat,
  getColor,
  dateHumanReadable,
  fnConvertUTCToString,
  fnDateTimeFromISO,
  dateUTCHumanReadable,
} from "common/global/functions.js"

const formateDate = (date, format) => {
  const dateFormat = format ? format : "DD MMM Y"
  const date1 = moment(new Date(date)).format(dateFormat)
  return date1
}
const toLowerCase1 = str => {
  return str === "" || str === undefined ? "" : str.toLowerCase()
}

const CheckBox = cell => {
  return (
    <input type="checkbox" className="form-check-input" value={cell.value} />
  )
}

const Href = cell => {
  return (
    <Link to="#" className="text-body fw-bold">
      {cell.value ? cell.value : ""}
    </Link>
  )
}

const Recourse = cell => {
  return (
    <Badge
      className={
        "font-size-11 badge-soft-" +
        (cell.value == "1"
          ? "primary"
          : cell.value == "2"
          ? "warning"
          : "light")
      }
    >
      {cell.value == 1
        ? "Full Recourse"
        : cell.value == 2
        ? "Mod Recourse"
        : "Non Recourse"}
    </Badge>
  )
}

const Status = cell => {
  return (
    <Badge
      className={
        "font-size-11 badge-soft-" +
        (cell.value == "Pending"
          ? "warning"
          : cell.value == "Approved"
          ? "info"
          : "danger")
      }
    >
      {cell.value}
    </Badge>
  )
}

const Active = cell => {
  return (
    <Badge
      className={
        "font-size-11 badge-soft-" +
        (cell.value == 1 ? "success" : cell.value == 2 ? "warning" : "danger")
      }
    >
      {cell.value == 1 ? "Active" : cell.value == 2 ? "Deactivated" : "Closed"}
    </Badge>
  )
}

const View = cell => {
  return (
    <Button
      type="button"
      color="primary"
      className="btn-sm btn-rounded"
      onClick={() => toggleViewModal(cell.value)}
      // outline
    >
      View
    </Button>
  )
}
const PaymentMethod = cell => {
  return (
    <span>
      <i
        className={
          cell.value === "Paypal"
            ? "fab fa-cc-paypal me-1"
            : "" || cell.value === "COD"
            ? "fab fas fa-money-bill-alt me-1"
            : "" || cell.value === "Mastercard"
            ? "fab fa-cc-mastercard me-1"
            : "" || cell.value === "Visa"
            ? "fab fa-cc-visa me-1"
            : ""
        }
      />{" "}
      {cell.value}
    </span>
  )
}

const Percent = cell => {
  return parseFloat(cell.value ? cell.value : "0").toFixed(2) + "%"
}

const Money = cell => {
  return USDFormat.format(cell.value ? cell.value : "0")
}

const String = cell => {
  return cell.value ? cell.value : ""
}

const Date = cell => {
  return dateUTCHumanReadable(cell.value)
}

export {
  CheckBox,
  Date,
  Percent,
  Money,
  String,
  Status,
  View,
  Recourse,
  Active,
}
